import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-personnel-grid',
  templateUrl: './update-personnel-grid.component.html',
  styleUrls: ['./update-personnel-grid.component.css']
})
export class UpdatePersonnelGridComponent implements OnInit {
  title="Update Personnel Information";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/personnel-details/Update-Personnel-Details/update-personnel-grid/update-personnel-grid.component.ts